<tm-filter-list-item *ngFor="let filter of (filters$ | async)"
                     [filter]="filter"></tm-filter-list-item>
